function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { textblockTypeInputRule, wrappingInputRule, inputRules } from 'prosemirror-inputrules';
import { leafNodeReplacementCharacter } from '../utils';
import { isConvertableToCodeBlock, transformToCodeBlockAction, insertBlock } from '../commands';
import { safeInsert } from 'prosemirror-utils';
import { createInputRule, defaultInputRuleHandler } from '../utils';
var MAX_HEADING_LEVEL = 6;

function getHeadingLevel(match) {
  return {
    level: match[1].length
  };
}

export function headingRule(nodeType, maxLevel) {
  return textblockTypeInputRule(new RegExp('^(#{1,' + maxLevel + '})\\s$'), nodeType, getHeadingLevel);
}
export function blockQuoteRule(nodeType) {
  return wrappingInputRule(/^\s*>\s$/, nodeType);
}
export function codeBlockRule(nodeType) {
  return textblockTypeInputRule(/^```$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {}
 */

function getHeadingRules(schema) {
  // '# ' for h1, '## ' for h2 and etc
  var hashRule = defaultInputRuleHandler(headingRule(schema.nodes.heading, MAX_HEADING_LEVEL), true);
  var leftNodeReplacementHashRule = createInputRule(new RegExp("".concat(leafNodeReplacementCharacter, "(#{1,6})\\s$")), function (state, match, start, end) {
    var level = match[1].length;
    return insertBlock(state, schema.nodes.heading, "heading".concat(level), start, end, {
      level: level
    });
  }, true);
  return [hashRule, leftNodeReplacementHashRule];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {}
 */


function getBlockQuoteRules(schema) {
  // '> ' for blockquote
  var greatherThanRule = defaultInputRuleHandler(blockQuoteRule(schema.nodes.blockquote), true);
  var leftNodeReplacementGreatherRule = createInputRule(new RegExp("".concat(leafNodeReplacementCharacter, "\\s*>\\s$")), function (state, _match, start, end) {
    return insertBlock(state, schema.nodes.blockquote, 'blockquote', start, end);
  }, true);
  return [greatherThanRule, leftNodeReplacementGreatherRule];
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {}
 */


function getCodeBlockRules(schema) {
  var threeTildeRule = createInputRule(/((^`{3,})|(\s`{3,}))(\S*)$/, function (state, match, start, end) {
    var attributes = {};

    if (match[4]) {
      attributes.language = match[4];
    }

    var newStart = match[0][0] === ' ' ? start + 1 : start;

    if (isConvertableToCodeBlock(state)) {
      var _tr = transformToCodeBlockAction(state, attributes) // remove markdown decorator ```
      .delete(newStart, end).scrollIntoView();

      return _tr;
    }

    var tr = state.tr;
    tr = tr.delete(newStart, end);
    var codeBlock = state.schema.nodes.code_block.createChecked();
    return safeInsert(codeBlock)(tr);
  }, true);
  var leftNodeReplacementThreeTildeRule = createInputRule(new RegExp("((".concat(leafNodeReplacementCharacter, "`{3,})|(\\s`{3,}))(\\S*)$")), function (state, match, start, end) {
    var attributes = {};

    if (match[4]) {
      attributes.language = match[4];
    }

    var tr = insertBlock(state, schema.nodes.code_block, 'codeblock', start, end, attributes);
    return tr;
  }, true);
  return [threeTildeRule, leftNodeReplacementThreeTildeRule];
}

export function blocksInputRule(schema) {
  var rules = [];

  if (schema.nodes.heading) {
    rules.push.apply(rules, _toConsumableArray(getHeadingRules(schema)));
  }

  if (schema.nodes.blockquote) {
    rules.push.apply(rules, _toConsumableArray(getBlockQuoteRules(schema)));
  }

  if (schema.nodes.code_block) {
    rules.push.apply(rules, _toConsumableArray(getCodeBlockRules(schema)));
  }

  if (rules.length !== 0) {
    return inputRules({
      rules: rules
    });
  }

  return;
}
export default blocksInputRule;